export const esc_p = (desc) => desc.replace(/[\n]/g, "\\n");
//# sourceMappingURL=esc.js.map